import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import * as Sentry from '@sentry/react';

import App from './App.jsx';
import './index.css';

// Sentry init (production only — skip in dev to avoid noise)
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        environment: import.meta.env.MODE,
        tracesSampleRate: 0.1,
    });
}

// Clerk publishable key — fail loudly if missing so we know
const CLERK_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!CLERK_KEY) {
    throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY. Set it in .env.local or Vercel env vars.');
}

// React Query client — sensible defaults for our use case
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30 * 1000,         // 30s: fresh data doesn't refetch
            refetchOnWindowFocus: false,   // don't refetch when tab regains focus; dispatch isn't that chatty
            retry: 1,                       // retry failed requests once
        },
    },
});
ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <ClerkProvider
            publishableKey={CLERK_KEY}
            signInForceRedirectUrl="/"
            signUpForceRedirectUrl="/"
            afterSignOutUrl="/sign-in"
        >
            <QueryClientProvider client={queryClient}>
                <BrowserRouter>
                    <App />
                    <Toaster position="top-right" richColors />
                </BrowserRouter>
            </QueryClientProvider>
        </ClerkProvider>
    </React.StrictMode>
);
